import { Box, Button, Snackbar, TextField, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import MainLayout from '../../layouts/MainLayout';
import { lemonSqueezyCheckoutID } from '../../lemonsqueezyConfig';
import { useAuthProvider } from '../../providers/AuthProvider';
import register from '../../services/api/users/register';
import ConnectWithButtons from './ConnectWithButtons';

const classes = {
    root: {
        my: 8,
        mx: 'auto',
        width: '90%',
        maxWidth: '450px',
    },
    frame: {
        padding: 6,
        margin: 'auto',
    },
    field: {
        marginTop: 2,
        marginBottom: 1,
        width: '100%',
    },
    alert: {
        width: '100%',
    },
    inviteSuccess: {
        width: '100%',
        marginBottom: 2,
    },
    submitButton: {
        marginTop: 3,
    },
};

const RegisterForm = () => {
    const router = useRouter();

    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const { isLoggedIn } = useAuthProvider();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isLoggedIn) {
            router.replace('/analyses');
        } else {
            setIsLoading(false);
        }
    }, [isLoggedIn]);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            email: '',
        },
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const onSubmit = async (formValues) => {
        setSnackbarOpen(false);
        setIsLoading(true);
        try {
            const { email } = formValues;
            await register({ email });
            window.location.href = `https://greenframe.lemonsqueezy.com/checkout/buy/${lemonSqueezyCheckoutID}?checkout[email]=${encodeURIComponent(
                email
            )}`;
        } catch (e) {
            setSnackbarOpen(true);
            setIsLoading(false);
        }
    };

    return (
        <MainLayout loader={isLoading}>
            <Box sx={classes.root}>
                <Typography variant="h2" gutterBottom>
                    Welcome to GreenFrame!
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    1 month free
                </Typography>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert severity="error" onClose={handleClose} variant="filled">
                        Your email is wrong or an account already exists.
                    </Alert>
                </Snackbar>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        name="email"
                        type="email"
                        control={control}
                        rules={{
                            required: {
                                value: true,
                                message: 'Email is required',
                            },
                            pattern: {
                                value: /\S+@\S+\.\S+/,
                                message: 'Email must have a valid format',
                            },
                        }}
                        render={({ field }) => (
                            <TextField
                                sx={classes.field}
                                name="email"
                                type="email"
                                label="Email"
                                variant="outlined"
                                color="secondary"
                                required={true}
                                size="small"
                                error={!!errors.email}
                                {...field}
                            />
                        )}
                    />

                    {errors.email && (
                        <Alert severity="error" sx={classes.alert}>
                            {errors.email.message}
                        </Alert>
                    )}

                    <Button
                        color="primary"
                        type="submit"
                        variant="contained"
                        sx={classes.submitButton}
                        fullWidth
                    >
                        Subscribe now
                    </Button>
                    {/* TODO : traiter le cas sign in with github */}
                    <ConnectWithButtons githubButtonLabel="Sign in with Github" />
                </form>
            </Box>
        </MainLayout>
    );
};

export default RegisterForm;
